// Vídeo das novidades criado fora do template: o WhatsNewService cria cedo (o navegador já começa a
// baixar quando o app abre) e a modal adota o mesmo elemento. O bucket não tem CORS, então fetch/blob
// não serve; o cache que vale é o do próprio <video>.

/** Elemento pronto pra stories: mudo (propriedade e atributo, pro autoplay), inline, pré-carregando. */
export function createStoryVideo(url: string): HTMLVideoElement {
  const video = document.createElement('video');
  video.muted = true;
  video.setAttribute('muted', '');
  video.playsInline = true;
  video.setAttribute('playsinline', '');
  video.preload = 'auto';
  video.src = url;
  return video;
}

/** Para o download (e a reprodução) de um vídeo que não vai mais ser usado. */
export function releaseStoryVideo(video: HTMLVideoElement): void {
  video.pause();
  video.removeAttribute('src');
  video.load();
}

/** Resolve quando o vídeo dá pra tocar até o fim (readyState >= 3 / canplaythrough), dá erro ou passa `maxMs`. */
export function whenPlayable(video: HTMLVideoElement | undefined, maxMs: number): Promise<void> {
  if (!video || video.readyState >= 3) return Promise.resolve();
  return new Promise<void>((resolve) => {
    const done = (): void => {
      clearTimeout(timer);
      video.removeEventListener('canplaythrough', done);
      video.removeEventListener('error', done);
      resolve();
    };
    const timer = setTimeout(done, maxMs);
    video.addEventListener('canplaythrough', done);
    video.addEventListener('error', done);
  });
}
